import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=5fcc47a6&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "../../../assets/css/case.css?vue&type=style&index=0&id=5fcc47a6&prod&scoped=true&lang=css&external"
import style1 from "../../../assets/css/chat.css?vue&type=style&index=1&id=5fcc47a6&prod&scoped=true&lang=css&external"
import style2 from "./Chat.vue?vue&type=style&index=2&id=5fcc47a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc47a6",
  null
  
)

export default component.exports